// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as FirebaseConfig from "./firebaseConfig";

let firebaseConfig = FirebaseConfig.firebaseConfig;

let AnalyticsProvider = {};

let AuthProvider = {};

let FirebaseAppProvider = {};

let FunctionsProvider = {};

let messagingContext = React.createContext(undefined);

let make = messagingContext.Provider;

let MessagingProvider = {
  make: make
};

function useMessaging() {
  return Stdlib_Option.getOrThrow(React.useContext(messagingContext), undefined);
}

let FirestoreProvider = {};

export {
  firebaseConfig,
  AnalyticsProvider,
  AuthProvider,
  FirebaseAppProvider,
  FunctionsProvider,
  messagingContext,
  MessagingProvider,
  useMessaging,
  FirestoreProvider,
}
/* firebaseConfig Not a pure module */
